export default __webpack_public_path__ + "static/media/9(Green-Delta-Aims-Tower).f628d34b.jpg";